import { AlloyDTO, AlloyDTOMetalGroupEnum, ProductGroup } from '../generated/api'

export function getAlloyGroupFromAlloys(alloys: AlloyDTO[], alloyName: string): AlloyDTOMetalGroupEnum {
    return alloys?.find((alloy) => alloy.materialNumber === alloyName)?.metalGroup as AlloyDTOMetalGroupEnum
}

export function getAlloyFromMaterialNumber(alloys: AlloyDTO[], materialNumber: string): AlloyDTO | undefined {
    return alloys.find((alloy) => alloy.materialNumber === materialNumber)
}

export function getAlloyIdFromName(alloys: AlloyDTO[], name: string) {
    return alloys?.find((alloy) => alloy.materialNumber === name)?.id
}

export function belongsToProductGroup(alloy: AlloyDTO, productGroup?: ProductGroup | undefined | null) {
    if (productGroup == null || alloy.productGroups == null) {
        return true
    }

    return alloy.productGroups.includes(productGroup)
}

export function getAlloyNameFromId(id: string, alloys: AlloyDTO[] = []): string {
    return id ? alloys.find((item) => item.id === id)?.materialNumber || '' : ''
}

export function checkIfCocAlloy(alloys: AlloyDTO[], alloyName?: string | null) {
    return alloyName && alloys.filter((x) => x.materialNumber === alloyName && x.metalGroup === 'COC').length > 0
}

export function getMetalGroupAlloys(alloys: AlloyDTO[], metalGroup: AlloyDTOMetalGroupEnum) {
    return alloys.filter((alloy) => alloy.metalGroup === metalGroup)
}

export function isWithinGroup(alloys: AlloyDTO[], metalGroup: AlloyDTOMetalGroupEnum, alloyName: string) {
    return !!getMetalGroupAlloys(alloys, metalGroup).find((alloy) => alloy.materialNumber === alloyName)
}

export function getTubeTolerance(alloys: AlloyDTO[], alloyName: string) {
    const alloy = getAlloyFromMaterialNumber(alloys, alloyName)
    if (!alloy?.hasTubeTolerance) {
        return null
    }
    return alloy.tubeTolerance
}

export function isWithinAu(alloys: AlloyDTO[], alloyName: string) {
    return (
        isWithinGroup(alloys, AlloyDTOMetalGroupEnum.Au333, alloyName) ||
        isWithinGroup(alloys, AlloyDTOMetalGroupEnum.Au376, alloyName) ||
        isWithinGroup(alloys, AlloyDTOMetalGroupEnum.Au585, alloyName) ||
        isWithinGroup(alloys, AlloyDTOMetalGroupEnum.Au750, alloyName) ||
        isWithinGroup(alloys, AlloyDTOMetalGroupEnum.Au917, alloyName) ||
        isWithinGroup(alloys, AlloyDTOMetalGroupEnum.Au990, alloyName)
    )
}

export const availableAlloyColors = [
    '5B3A29',
    '9D8D73',
    '948A7E',
    '918376',
    'A19C98',
    'A89F8E',
    'A0997F',
    'A59585',
    'B4866E',
    'BA986A',
    'BBA37F',
    'C2AD78',
    'C4A878',
    'C39F7D',
    'CAAC6C',
    'CBA864',
]
